module.exports = __webpack_public_path__ + "static/tmp-blog-ads-1-92947675d20cc6997e3c0e580c675c9d.png";